import { useMemo } from 'react';
import { ResponseProductType } from '@/data/types/Product';
import { ResponseProductAttribute } from '@/data/types/Product';

export const isProductStoreOnlyAvailable = ({
	productAttributes,
	marketId,
}: {
	productAttributes: ResponseProductAttribute[] | undefined;
	marketId: string | undefined;
}): boolean => {
	if (!productAttributes || !marketId) {
		return false;
	}

	const proStoreOnlyAvailable = productAttributes?.find(
		(e) => e.identifier === 'PRO_STORE_ONLY_AVAILABLE'
	);

	const storeOnlyAvailable = productAttributes?.find(
		(e) => e.identifier === 'STORE_ONLY_AVAILABLE'
	);

	const check = (attribute: ResponseProductAttribute) => {
		const values = attribute.values;
		if (!values?.length) return false;

		const value = values[0]?.value;
		if (Array.isArray(value)) return value.includes(marketId);

		const found = values.find((v) => v.value === marketId);
		return !!found;
	};

	const isProStoreOnlyAvailable = proStoreOnlyAvailable ? check(proStoreOnlyAvailable) : false;

	const isStoreOnlyAvailable = storeOnlyAvailable ? check(storeOnlyAvailable) : false;

	return isProStoreOnlyAvailable || isStoreOnlyAvailable;
};

export const useIsProductStoreOnlyAvailable = ({
	product,
	marketId,
}: {
	product: ResponseProductType | undefined;
	marketId: string | undefined;
}) => {
	const productAttributes = product?.attributes;

	return useMemo(
		() => isProductStoreOnlyAvailable({ productAttributes, marketId }),
		[productAttributes, marketId]
	);
};
